var videoPageHandler = {

	$panelLoading: jQuery('.panel-loading'),
	$switchContainer: jQuery('.switch-container'),
	$switchView: jQuery(".switch-container #switch-view"),
	$searchContainer: jQuery('.js-trigger-search-for-small'),
	$filterBox: jQuery('.js-trigger-search-for-small input.filterBox'),
	$searchSuggestion: jQuery('.suggested-search'),
	$searchSuggestionSmall: jQuery('.suggested-search.suggested-search-small'),
	$suggestionList = jQuery('.list-suggested'),
	$searchedTagsContainer: jQuery('.search-container-small .item-searched-container'),
	$captionTags = jQuery('.caption-tags'),

	suggestionTimer = null,

	masonryInitialized: false,

	initMasonry: function() {
		if (this.currentVideoView == 'grid' && !this.masonryInitialized) {
			// 20210603 kick out masonry. CSS display grid FTW!!!!
			// this commented code is the artifact of how often simple but sophisticated mindset
			// wins the day.
			// jQuery('.video-index > .grid-x.grid-view').masonry({
			// 	itemSelector: '.content-item',
			// 	columnWidth: '.content-sizer',
			// 	percentPosition: true
			// });
			this.masonryInitialized = true;	
		}
	},

	currentVideoView: 'list',
	
	switchVideoView: function(isChecked) {
		if (isChecked) {
			this.currentVideoView = 'grid';
			jQuery("main").find(".list-view-content").addClass("hide");
			jQuery("main").find(".grid-view-content").removeClass("hide");
			document.cookie = "view="+escape('grid')+ ";expires=0; path=/";
		} else {
			this.currentVideoView = 'list';
			jQuery("main").find(".grid-view-content").addClass("hide");
			jQuery("main").find(".list-view-content").removeClass("hide");
			document.cookie = "view="+escape('list')+ ";expires=0; path=/";
		}
		this.$panelLoading.addClass('hide');
		if (this.currentVideoView == 'grid') {
			mainHandler.resizeVideoThumbnails();
			this.initMasonry();	
		}
	},

	focusSearch: function() {
		this.$searchContainer.removeClass('small-inactive');
		this.$filterBox.trigger("focus");
		this.$switchContainer.addClass('hide-switch');
	},

	unfocusSearch: function() {
		this.$switchContainer.removeClass('hide-switch');
		this.$searchContainer.addClass('small-inactive');
		this.$searchSuggestion.addClass('hidden');
		this.setMarginContent(0);
	},

	updateUrl: function(isChecked) {
		var url = window.location.href;
		var new_url = '';
		if (isChecked) {
			if (url.includes("#list")) {
				new_url = url.replace('#list', '#grid');
			} else if (!url.includes("#grid")) { 
				new_url = url + '#grid-view';
			}
		} else {
			if (url.includes("#grid")) {
				new_url = url.replace('#grid', '#list');
			} else if (!url.includes("#list")) { 
				new_url = url + '#list-view';
			} 
		}
		window.location.href = new_url;
	},

	lookupSuggestion: function(val) {
		var self = this;
		if (val.length >= 3) {
			this.suggestionTimer = setTimeout(function() {
				self.$suggestionList.empty();
				self.setMarginContent(0);
				jQuery.ajax({
					type: 'post',
					url: myAjax.ajax_url,
					data: {
						action: 'load_search_suggest',
						search: val,
					},
					success: function(response) {
						self.renderSuggestion(response);	
					}
				});	
			}, 300);
		}
	},

	renderSuggestion: function(data) {
		this.$suggestionList.empty();
		this.$searchSuggestion.removeClass('hidden');
		this.setMarginContent(0);
		for (var i = 0; i < data.length; i++) {
			jQuery("<li>"+data[i]['name']+"</li>")
			.attr({
				'class': 'trigger-click-item-search',
				'value': data[i]['slug'],
				'id': data[i]['term_id']
			}).appendTo(this.$suggestionList);
		}
		this.setMarginContent(this.$searchSuggestionSmall.height());
	},

	executeSuggestion: function($searchItem) {
		var id = $searchItem.attr('id');
		var $showedItem = jQuery(".item-searched[data-target-id="+id+"]");		
		$showedItem.removeClass('hide');
		this.$filterBox.val('');
		this.$suggestionList.empty();
		this.setMarginContent(0);
		this.saveTagToCookie(id);
		this.reloadVideos();
		this.updateTagsDisplay();
	},

	reloadVideos: function() {
		var self = this;
		var tag = Cookies.get('tag');
		this.$panelLoading.removeClass('hide');
		// remove current view
		jQuery('.grid-view-content').remove();
		jQuery('.list-view-content').remove();
		jQuery.ajax({
			type: 'post',
			url: myAjax.ajax_url,
			data: {
				action: 'reload_video',
				query: tag,
			},
			success: function(response) {
				if (response['state'] == 'ok') {					
					// add filtered view
					self.$panelLoading.addClass('hide');
					self.$panelLoading.after(response['html']);
					self.switchVideoView((response['view'] == 'grid'));
					mainHandler.resizeVideoThumbnails();
					self.masonryInitialized = false;
					if (self.currentVideoView == 'grid') {
						self.initMasonry();	
					}
				}	
			}
		});
	},

	setMarginContent: function(height) {
		if (height > 38) height = height - 38;
		if (height == 0) {
			this.$searchSuggestionSmall.removeClass('shadowed');
		} else {
			this.$searchSuggestionSmall.addClass('shadowed');
		}
	},

	saveTagToCookie: function(id) {
		var tagsOnCookie = []; 
		var cook = Cookies.get('tag');
		if (cook != null) {
			JSON.parse(cook).forEach(e => {
				tagsOnCookie.push(e);
			});
		}
		if (tagsOnCookie.indexOf(id) == -1) {
			tagsOnCookie.push(id);
		}
		Cookies.set('tag', JSON.stringify(tagsOnCookie));
	},

	removeTagFromCookie: function(id) {
		var cook = []; 
		cook = JSON.parse(Cookies.get('tag'));
		cook = jQuery.grep(cook, function(value) {
			return value != id;
		});
		Cookies.set('tag', JSON.stringify(cook));	
	},

	updateTagsDisplay: function() {
		var dataAvail = JSON.parse(Cookies.get('tag'));
		if (dataAvail.length == 0) {
			this.$searchedTagsContainer.addClass('empty');
			this.$captionTags.addClass('hide');
		} else {
			this.$searchedTagsContainer.removeClass('empty');
			this.$captionTags.removeClass('hide');
		}
	},

	unfilterTag: function($tag) {
		this.$captionTags.addClass('hide');
		//$('body').find('.search-container-small').addClass('hide');
		var id = $tag.data('target-id');
		var $showedItem = jQuery(".item-searched[data-target-id="+id+"]");		
		$showedItem.addClass('hide');
		this.removeTagFromCookie(id);
		this.reloadVideos();
		this.updateTagsDisplay();
	},

	initialize: function() {

		var isOnVideoPage = jQuery('body.page-template-page-video').length > 0;
		if (!isOnVideoPage) return;

		var self = this;

		// focus/unfocus search box
		this.$searchContainer.on("click", function(e){
			self.focusSearch();
		});
		this.$filterBox.on("focusout", function(e){
			self.unfocusSearch();
		});	

		// list/grid view switch
		if (this.$switchView.length > 0) {
			this.switchVideoView(this.$switchView.get(0).checked);
			this.$switchView.on("change", function(e) {
				e.preventDefault();
				var isChecked = jQuery(this).is(":checked");
				self.updateUrl(isChecked);
				self.switchVideoView(isChecked);
			});	
		}

		// search suggestion related
		this.$filterBox.on("keyup", function(e) {
			var val = jQuery(this).val().trim();
			clearTimeout(self.suggestionTimer);
			self.lookupSuggestion(val);
		});
		jQuery('body').on('click', '.trigger-click-item-search', function(e) {
			self.executeSuggestion(jQuery(this));
		});
		jQuery('body').on('click', '.item-searched', function(e) {
			self.unfilterTag(jQuery(this));
		});			
		this.initMasonry();
	},

};


jQuery(document).ready(function($) {
	videoPageHandler.initialize();
});
